import { Module, MutationTree, ActionTree, GetterTree } from "vuex"
import { RootState } from "@/store"

export interface NavigationContextState {
    sourceRoute: string | null
    sourcePath: string | null
    sourceTitle: string | null
    returnPath: string | null
}

const STORAGE_KEY = "navigationContext"

const loadState = (): NavigationContextState => {
    try {
        const saved = localStorage.getItem(STORAGE_KEY)
        if (saved) {
            const parsed = JSON.parse(saved)

            if (
                parsed.sourceRoute &&
                parsed.sourcePath &&
                parsed.sourceTitle &&
                parsed.returnPath
            ) {
                return parsed
            }
        }
    } catch (e) {
        console.error("Error loading navigation context:", e)
    }

    return {
        sourceRoute: null,
        sourcePath: null,
        sourceTitle: null,
        returnPath: null,
    }
}

const state: NavigationContextState = loadState()

const mutations: MutationTree<NavigationContextState> = {
    SET_CONTEXT(
        state,
        payload: {
            sourceRoute: string
            sourcePath: string
            sourceTitle: string
            returnPath: string
        },
    ) {
        state.sourceRoute = payload.sourceRoute
        state.sourcePath = payload.sourcePath
        state.sourceTitle = payload.sourceTitle
        state.returnPath = payload.returnPath
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
        } catch (e) {
            console.error("Error saving navigation context:", e)
        }
    },
    CLEAR_CONTEXT(state) {
        state.sourceRoute = null
        state.sourcePath = null
        state.sourceTitle = null
        state.returnPath = null
        try {
            localStorage.removeItem(STORAGE_KEY)
        } catch (e) {
            console.error("Error clearing navigation context:", e)
        }
    },
}

const actions: ActionTree<NavigationContextState, RootState> = {
    setNavigationContext(
        { commit },
        payload: {
            sourceRoute: string
            sourcePath: string
            sourceTitle: string
            returnPath: string
        },
    ) {
        commit("SET_CONTEXT", payload)
    },
    clearNavigationContext({ commit }) {
        commit("CLEAR_CONTEXT")
    },
}

const getters: GetterTree<NavigationContextState, RootState> = {
    hasContext: (state) => !!state.sourceRoute,
    getContext: (state) => ({
        sourceRoute: state.sourceRoute,
        sourcePath: state.sourcePath,
        sourceTitle: state.sourceTitle,
        returnPath: state.returnPath,
    }),
}

const navigationContextModule: Module<NavigationContextState, RootState> = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}

export default navigationContextModule
